import { XCircleIcon } from "@heroicons/react/20/solid";

export function ErrorAlert({ text }: { text: string }) {
	return (
		<div className="eL-rounded-md eL-bg-red-50 eL-p-4 eL-mt-2">
			<div className="eL-flex">
				<div className="eL-flex-shrink-0">
					<XCircleIcon className="w-5 eL-h-5 eL-text-red-600" aria-hidden="true" />
				</div>
				<div className="eL-ml-3">
					<h3 className="eL-text-sm !eL-my-0 eL-font-medium eL-text-red-800">{text}</h3>
				</div>
			</div>
		</div>
	);
}
